import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Formik } from "formik";
import InputWrapper from "./InputWrapper";
import ButtonWrapper from "./ButtonWrapper";
import SelectWrapper from "./SelectWrapper";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import postQrInitManualTransaction from "../redux/actions/postQrInitManual";
import * as Yup from "yup";
import { bankNames, toLocaleStringFormate } from "../helpingFunctions";
import { language } from "../utils/language";
import MainWrapper from "./MainWrapper";
import WarningModal from "./WarningModal";
import { Fade, Reveal, Slide } from "react-awesome-reveal";
import getVerifyManualTransaction from "../redux/actions/getVerifyManualTransaction";
import LanugageSelector from "./LanugageSelector";
import { CloseCircleOutlined } from "@ant-design/icons";

const CardWrapper = styled(Slide)`
  height: auto;
  z-index: 999;
  @media (min-width: 280px) and (max-width: 768px) {
    width: 90%;
  }
  width: 30%;
  background: #fff;
  // padding: 20px 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  .card-header {
    background: #162056;
    padding: 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  h3 {
    color: white;
  }
`;

const AutoMethodTransactionInfoCard = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const { data } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );

  const { modalShow, modalData } = useSelector(
    (state) => state.warningModalReducer
  ); //Warning modal data
  const { lang } = useSelector((state) => state.languageSelectorReducer);

  const transactionSchema = Yup.object().shape({
    bank: Yup.string().required(language[lang].trnxInfoCard.ERROR_PSB),
    accountNo: Yup.string()
      .matches(/^[0-9\s]+$/, "Only Numeric are allowed for this field")
      .min(5, language[lang].trnxInfoCard.ERROR_EAN)
      .max(5, language[lang].trnxInfoCard.ERROR_EAN_MAX)
      .required(language[lang].trnxInfoCard.ERROR_EAN),
  });

  // -----checking link is verify or not---------
  const { error } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );

  useEffect(() => {
    dispatch(getVerifyManualTransaction(params.id));
  }, []);

  useEffect(() => {
    if (error) {
      navigate(`/${params.id}`);
    }
  }, [error]);

  const [bankNameLang, setBankNameLang] = useState(state?.bankName);
  useEffect(() => {
    if (state) {
      let findBankName = bankNames.find(
        (item) =>
          item.bankNameEng == bankNameLang || item.bankNameThai == bankNameLang
      );
      lang == "en"
        ? setBankNameLang(findBankName.bankNameEng)
        : setBankNameLang(findBankName.bankNameThai);
    }
  }, [state, lang]);

  return (
    <div className="" style={{ height: "100vh" }}>
      <WarningModal
        visible={modalShow}
        lang={lang}
        closeIcon={
          <CloseCircleOutlined
            style={{ position: "absolute", right: 10, top: 10 }}
            onClick={() =>
              dispatch({
                type: "WARNING_MODAL_CLOSE",
                payLoad: false,
                data: "",
              })
            }
          />
        }
        maskClosable={false}
        // centered={true}
        footer={null}
        bodyStyle={{ borderRadius: 10 }}
        width={370}
      />
      <MainWrapper>
        <CardWrapper className="">
          <div className="card-header w-100">
            <h3 className="text-center">{language[lang].trnxInfoCard.PTI}</h3>
          </div>
          <Formik
            initialValues={{
              bank: state ? bankNameLang : "",
              accountNo: state ? state?.accountNumber : "",
            }}
            validationSchema={transactionSchema}
            onSubmit={(values) => {
              let getBankName = bankNames.filter(
                (item) =>
                  item.bankNameThai == values.bank ||
                  item.bankNameEng == values.bank
              );
              let qrManualTransactionParams = {
                qrCodeTransactionId: data.trxRef,
                type: window.location?.pathname?.split("/")[2]?.split("-")[0],
                amount: parseFloat(data?.amount),
                sessionId: data.sessionToken,
                bankCode: getBankName[0].bankCode,
                bankName: getBankName[0].bankNameEng,
                accountNumber: values.accountNo,
                userId: data.merchantId,
              };
              if (values && data.merchantId) {
                if (
                  window.location?.pathname?.split("/")[2]?.split("-")[0] ==
                  "auto"
                ) {
                  navigate(`/${params.id}/confirmation-warning-thaiqr`, {
                    state: { qrManualTransactionParams },
                  });
                } else {
                  dispatch({
                    type: "WARNING_MODAL_SHOW",
                    payLoad: true,
                    data: qrManualTransactionParams,
                  });
                }
              }
            }}
            enableReinitialize={true}
          >
            {({
              onSubmit,
              values,
              errors,
              handleChange,
              handleSubmit,
              resetForm,
            }) => (
              <form noValidate onSubmit={handleSubmit} className="w-100 p-3">
                <div className="mt-3 d-flex align-items-center justify-content-between">
                  <p className="text-center fw-bold">
                    {language[lang].trnxInfoCard.PAYER_BANK_DETAILS}
                  </p>
                  <LanugageSelector />
                </div>
                <p className="label mb-0 fw-bold">
                  {language[lang].trnxInfoCard.BANK}*
                </p>
                <SelectWrapper
                  name="bank"
                  size="large"
                  value={values.bank == "" ? null : <span>{values.bank}</span>}
                  placeholder={`${language[lang].trnxInfoCard.SELECT_BANK}`}
                  bankMenu={bankNames}
                  onChange={handleChange("bank")}
                />
                {errors.bank ? (
                  <p className="mb-4" style={{ color: "red" }}>
                    {errors.bank}
                  </p>
                ) : (
                  <p className="mb-4"></p>
                )}

                <p className="label mb-0 fw-bold">
                  {language[lang].trnxInfoCard.ACCOUNT_NO}*
                </p>
                <InputWrapper
                  style={{ borderRadius: 10, marginTop: 0 }}
                  name="accountNo"
                  type="text"
                  size="large"
                  value={values.accountNo}
                  onChange={handleChange("accountNo")}
                  placeholder={
                    language[lang].trnxInfoCard.BANK_CODE_PLACEHOLDER
                  }
                />
                {errors.accountNo ? (
                  <p className="mb-4" style={{ color: "red" }}>
                    {errors.accountNo}
                  </p>
                ) : (
                  <p className="mb-4"></p>
                )}

                <div className="d-flex ">
                  <p className="label fw-bold mb-0">
                    {language[lang].trnxInfoCard.AMOUNT}(฿)*
                  </p>
                  <p className="label fw-bold mb-0 ms-5">
                    {toLocaleStringFormate(data?.amount)}
                  </p>
                </div>

                <div className="w-100">
                  <ButtonWrapper
                    border={true}
                    size="middle"
                    height="40px"
                    htmlType="submit"
                    className="w-100 mt-4"
                    text={language[lang].trnxInfoCard.PROCEED_PAYMENT}
                  />
                </div>
              </form>
            )}
          </Formik>
        </CardWrapper>
      </MainWrapper>
    </div>
  );
};

export default AutoMethodTransactionInfoCard;
